import { render, staticRenderFns } from "./slideshowdetails.vue?vue&type=template&id=746fb203&scoped=true&"
import script from "./slideshowdetails.vue?vue&type=script&lang=js&"
export * from "./slideshowdetails.vue?vue&type=script&lang=js&"
import style0 from "./slideshowdetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./slideshowdetails.vue?vue&type=style&index=1&id=746fb203&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746fb203",
  null
  
)

export default component.exports